import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

// readiness 6..30, attractiveness 6..30
const MatrixCard = ({ readiness = 18, attractiveness = 22, className = '' }) => {
  const intl = useIntl();
  const quadrant = useMemo(() => {
    const readyHigh = Number(readiness || 0) >= 18;
    const attractHigh = Number(attractiveness || 0) >= 18;
    if (attractHigh && readyHigh) return 'best_zone';
    if (attractHigh && !readyHigh) return 'fix_owner';
    if (!attractHigh && readyHigh) return 'fix_business';
    return 'danger_zone';
  }, [readiness, attractiveness]);

  const cellClass = (key) => {
    const base = 'rounded-none border flex flex-col items-center justify-center gap-2 text-center p-3 md:p-4 text-sm md:text-base transition-all min-h-[12rem]';
    const isActive = quadrant === key;
    return (
      base + ' ' + (isActive ? 'border-succession-primary animate-pulse ring-1 ring-succession-primary/30' : 'border-succession-border')
    );
  };

  const chip = (key, label, colorClasses) => (
    <div className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-semibold ${colorClasses}`}>{label}</div>
  );

  return (
    <div className={`h-72 md:h-80 flex flex-col p-0 md:p-0 ${className}`}>
      <div className="text-lg font-semibold text-succession-foreground mb-2 px-2">{intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.title' })}</div>
      <div className="grid grid-cols-2 grid-rows-2 gap-0 w-full flex-1">
        {/* Top row (Attractive) */}
        <div className={cellClass('fix_owner')}>
          {chip('fix_owner', intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.fix_owner_label' }), 'text-black bg-succession-warning')}
          <p className="text-succession-foreground text-[11px] md:text-xs leading-relaxed mt-1 md:mt-2">{intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.fix_owner_desc' })}</p>
        </div>
        <div className={cellClass('best_zone')}>
          {chip('best_zone', intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.best_zone_label' }), 'text-white bg-succession-success')}
          <p className="text-succession-foreground text-[11px] md:text-xs leading-relaxed mt-1 md:mt-2">{intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.best_zone_desc' })}</p>
        </div>
        {/* Bottom row (Not Attractive) */}
        <div className={cellClass('danger_zone')}>
          {chip('danger_zone', intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.danger_zone_label' }), 'text-white bg-succession-error')}
          <p className="text-succession-foreground text-[11px] md:text-xs leading-relaxed mt-1 md:mt-2">{intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.danger_zone_desc' })}</p>
        </div>
        <div className={cellClass('fix_business')}>
          {chip('fix_business', intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.fix_business_label' }), 'text-black bg-succession-warning')}
          <p className="text-succession-foreground text-[11px] md:text-xs leading-relaxed mt-1 md:mt-2">{intl.formatMessage({ id: 'succession.value_acceleration.matrix_card.fix_business_desc' })}</p>
        </div>
      </div>
    </div>
  );
};

export default MatrixCard;


